/* sugar:assets/story-cards.js@2.1.7 */
/*
  Story Cards (sections/story-cards.liquid).

  Focus row: a click, Enter/Space or keyboard focus on a card makes it the big one. The row is
  drawn by the stylesheet from one class, so a pick only moves that class.

  Slider: mounted with Splide and the shared slider chrome only at the widths whose layout is
  "slider" (desktop from 750 or 1024px, phones below), and torn down when the width crosses the
  switch. Slide widths come from the stylesheet (autoWidth), so the row before and after mount
  is the same row.
*/
(function () {
  'use strict';
  if (window.customElements.get('sugar-story-cards')) return;

  var FOCUS = 'sugar-story-cards__card--focus';

  class SugarStoryCards extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: ' + (this.dataset.from === '1024' ? 1024 : 750) + 'px)');
      this.onPick = this.onPick.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onSelect = this.onSelect.bind(this);
      this.sync = this.sync.bind(this);
      this.addEventListener('click', this.onPick);
      this.addEventListener('focusin', this.onPick);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('shopify:block:select', this.onSelect);
      this.mq.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onPick);
      this.removeEventListener('focusin', this.onPick);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('shopify:block:select', this.onSelect);
      this.mq.removeEventListener('change', this.sync);
      this.unmount();
    }

    mode() {
      return this.mq.matches ? this.dataset.d : this.dataset.m;
    }

    cards() {
      return this.querySelectorAll('.sugar-story-cards__card');
    }

    focusCard(card) {
      if (!card || card.classList.contains(FOCUS)) return;
      Array.prototype.forEach.call(this.cards(), function (c) {
        var on = c === card;
        c.classList.toggle(FOCUS, on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    onPick(event) {
      if (!this.mq.matches || this.dataset.d !== 'focus') return;
      this.focusCard(event.target.closest('.sugar-story-cards__card'));
    }

    onKey(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('.sugar-story-cards__card');
      if (!card || event.target !== card) return;
      event.preventDefault();
      this.onPick(event);
    }

    onSelect(event) {
      if (!this.contains(event.target)) return;
      var card = event.target.closest('.sugar-story-cards__card');
      if (!card) return;
      if (this.mode() === 'focus') this.focusCard(card);
      if (this.splide) this.splide.go(Array.prototype.indexOf.call(this.cards(), card));
    }

    sync() {
      this.unmount();
      if (this.mode() === 'slider') this.mount();
    }

    mount() {
      var self = this;
      var track = this.querySelector('.sugar-story-cards__track.splide');
      if (!track || this.cards().length < 2) return;
      var go = function () {
        if (self.splide || !window.Splide || self.mode() !== 'slider' || !self.isConnected) return;
        var gap = parseInt(self.mq.matches ? self.dataset.gapD : self.dataset.gapM, 10) || 0;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        self.splide = new window.Splide(track, {
          type: 'slide',
          autoWidth: true,
          gap: gap + 'px',
          perMove: 1,
          arrows: false,
          pagination: false,
          trimSpace: true,
          speed: reduce ? 0 : 500,
        });
        self.splide.mount();
        if (window.SugarSliderChrome) self.chrome = window.SugarSliderChrome.attach(self.splide, self, { dotMode: 'page' });
      };
      if (window.Splide) go();
      else if (window.SugarVendor && window.SugarVendor.loadSplide) window.SugarVendor.loadSplide().then(go).catch(function () {});
    }

    unmount() {
      if (this.chrome) {
        try { this.chrome.detach(); } catch (e) {}
        this.chrome = null;
      }
      if (this.splide) {
        try { this.splide.destroy(true); } catch (e) {}
        this.splide = null;
      }
    }
  }

  window.customElements.define('sugar-story-cards', SugarStoryCards);
})();
